module.exports = __webpack_public_path__ + "img/booking-screenshot.cc5a01e3.png";